import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { onNavToggle } from '../../../state-actions/onNavToggle';
import HeaderNavToggleStyled, { SVG, Circle } from './HeaderNavToggle.styled';

const mapStateToProps = state => ({
  open: state.nav.open,
});

const mapDispatchToProps = dispatch => ({
  onNavToggle: bool => dispatch(onNavToggle(bool)),
});

export const HeaderNavToggle = ({ open, onNavToggle }) => (
  <HeaderNavToggleStyled
    className={open && 'open'}
    onClick={() => onNavToggle(!open)}
    title="How to Noodle"
  >
    <SVG viewBox="0 0 100 100">
      <Circle cx="50" cy="50" r="40" />
    </SVG>
  </HeaderNavToggleStyled>
);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HeaderNavToggle);

HeaderNavToggle.propTypes = {
  open: PropTypes.bool.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/atoms/HeaderNavToggle/HeaderNavToggle.js